export function addAriaLabelsToLinks() {
    const newTabLinks = document.querySelectorAll('a[target="_blank"]');

    if(newTabLinks.length < 0) return;

    newTabLinks.forEach(link => {
        const srElement = link.querySelector('span.screen-reader-text');

        if(srElement) {
            if (srElement.textContent !== 'Opens in a new tab') {
                const srElement = document.createElement('span');
                srElement.classList.add('screen-reader-text');
                srElement.textContent = 'Opens in a new tab';
                link.appendChild(srElement);
            }
        }

    })
}


// WEBPACK FOOTER //
// ./scripts/modules/aria-links.js